import { useQuery } from "@tanstack/react-query";
import { BaseModal, ModalCloseCross, type BaseModalProps } from "../../../../components/modals/BaseModal";
import { ComunicacionAjax } from "../../../../ts/api/comunicacion";
import { useMemo, useState } from "react";
import type { DBPrioritaria } from "../SincroAlmacen";
import { TypedTable } from "../../../../components/TypedTable";
import { createColumnHelper } from "@tanstack/react-table";
import { Loading, QueryError } from "../../../../components/Loading/Loading";


interface ModalLogSincroProps extends BaseModalProps {
}
export function ModalLogsSincro(props: ModalLogSincroProps) {
	// $("#comboLogSincro").on("change", function (this: HTMLElement) {
	// 	const logcab_id = $(this).val() as string;
	// 	void getLineasSincronizacion(logcab_id);
	// });
	const [logCabID, setLogCabID] = useState<number | null>(null);


	return (
		<BaseModal show={props.show} close={props.close}>
			<div className="modal-header">
				<h4 className="modal-title">Historial de logs</h4>
				<ModalCloseCross onClick={props.close} />
			</div>
			<div className="modal-body">
				<FiltroCabecera idLogCabSincro={logCabID} setLogCabID={setLogCabID} />
				<TablaLogSincro idLogCabSincro={logCabID} />
			</div>
			<div className="modal-footer">
				<button type="button" className="btnSecondary" onClick={props.close}>
					Cerrar
				</button>
			</div>
		</BaseModal>
	);
}

function FiltroCabecera(props: { readonly idLogCabSincro: number | null; readonly setLogCabID: (id: number | null) => void; }) {
	const { data, error, isPending } = useLogsCabecera();

	if (error) return <QueryError error={error} fallback="Error al cargar los datos" />;
	if (isPending) return <Loading />;

	return (
		<div style={{ padding: 30, display: "flex" }}>
			<label style={{ fontSize: 17, marginTop: 6, marginRight: 5, width: "45%" }}>Selecciona un registro: </label>
			<select className="form-control limpiar" value={props.idLogCabSincro ?? ""} onChange={e => props.setLogCabID(Number(e.target.value) || null)}>
				<option selected value=''>Seleccion una opción</option>
				{data.data.map((linea) => (
					<option key={linea.id} value={linea.id}> {linea.id} - {linea.xfecha}</option>
				))}
			</select>
		</div>
	);
}

function TablaLogSincro(props: { readonly idLogCabSincro: number | null; }) {
	function prioritariaADireccion(prioritaria: DBPrioritaria) {
		if (prioritaria == "EKON") return "ERP>MRP";
		else return "MRP>ERP";
	}

	const { data, error, isPending } = useLogsLinea(props.idLogCabSincro);

	const columns = useMemo(() => {
		const columnHelper = createColumnHelper<LogSincro>();
		return [
			columnHelper.accessor("prioritaria", { header: "Direccion", meta: { className: "dt-center" }, cell: info => prioritariaADireccion(info.getValue()) }),
			columnHelper.accessor("almacen_id", { header: "Almacén", meta: { className: "dt-center" } }),
			columnHelper.accessor("articulo_id", { header: "Artículo", meta: { className: "dt-center" } }),
			// columnHelper.accessor(row => "WIP: SUMA", { header: "Tipo", meta: { className: "dt-center" } }),
			columnHelper.accessor("cantidad_sumar", { header: "Cantidad", meta: { className: "dt-center" } }),
		];
	}, []);

	if (error) return <QueryError error={error} fallback="Error al cargar los datos" />;
	if (isPending) return <Loading />;
	if (data === null) return <div>Selecciona un log de sincronización</div>;


	return (
		<TypedTable
			// "scrollY": "400px",
			// "scrollCollapse": true,
			className="dataTable display"
			columns={columns}
			data={data}
			pagination
		/>
	);
}

function useLogsCabecera() {
	return useQuery({
		queryKey: ["getLogsCab"],
		queryFn: () => {
			return ComunicacionAjax.sendAjaxRequest<RespuestaLogsCab>("GET", "/api/v1/getLogsCab");
		},
	});
}
function useLogsLinea(logcab_id: number | null) {
	return useQuery<LogSincro[] | null>({
		queryKey: ["getLogsSincro", logcab_id],
		queryFn: () => {
			const url = "/api/v1/getLogsSincro";
			if (logcab_id === null) return Promise.resolve(null);
			return ComunicacionAjax.sendAjaxRequest<LogSincro[]>("GET", url, { "idLogCabSincro": logcab_id });
		},
	});
}
interface RespuestaLogsCab {
	data: Array<{ id: number; xfecha: string; }>;
}
interface LogSincro {
	id: number;
	logcabsincro_id: number;
	articulo_id: string;
	almacen_id: string;
	prioritaria: DBPrioritaria;
	cantidad_sumar: number;
}
